import { useEffect } from "react";
import { observer } from "mobx-react";
import { useParams } from "react-router-dom";

import useStores from "../../../../utils/useStores";

import "./style.css";

const QuestionList = observer(() => {
    const { subject_user, subject_slug } = useParams<{ subject_user: string; subject_slug: string }>();
    const rootStore = useStores();

    useEffect(() => {
        if (subject_user && subject_slug) {
            rootStore.questionListStore.fetch(subject_user, subject_slug);
        }
    }, [subject_user, subject_slug, rootStore]);

    console.log(rootStore.questionListStore.subjectTracking);
    var tableRows: JSX.Element[] = [];

    rootStore.questionListStore.questions.forEach(
        (question: any, i: number) => {
            let dataTypeLocator = ""
            if (question.dataTypeLocator) {
                dataTypeLocator = question.dataTypeLocator.join()
            }
            tableRows.push(
                <tr key={i}>
                    <td>{i}</td>
                    <td>{question.quiz_subject}</td>
                    <td>{question.quiz_object}</td>
                    <td>{question.ask_after}</td>
                    <td>{question.dataType}</td>
                    <td>{question.dataTypeID}</td>
                    <td>{question.dataTypeSecondaryID}</td>
                    <td>{dataTypeLocator}</td>
                    <td>{question.score}</td>

                </tr>
            );
        }
    );

    // TODO: Finish This
    let stats = <div></div>
    if (rootStore.questionListStore.subjectTracking) {
        stats = (
            <div className="row">
                Subject Daily Active Percent: {rootStore.questionListStore.subjectTracking.daily_active_percent}<br />
                Subject Daily Starting Percent: {rootStore.questionListStore.subjectTracking.daily_starting_percent}<br />
                Subject Daily Questions Left: {rootStore.questionListStore.subjectTracking.daily_questions_left}<br />
                Subject Daily Questions Total: {rootStore.questionListStore.subjectTracking.daily_questions_total}<br />
                Subject Total Completion Percent: {rootStore.questionListStore.subjectTracking.total_completion_percent}<br />
            </div>
        )
    }
    return (
        <div>
            {stats}
        <table className="table">
            <thead>
                <tr>
                    <th>I</th>
                    <th>Quiz Subject</th>
                    <th>Quiz Object</th>
                    <th>Ask After</th>
                    <th>Data Type</th>
                    <th>Data Type ID</th>
                    <th>Data Type Secondary ID</th>
                    <th>Data Type Locator</th>
                    <th>Score</th>
                </tr>
            </thead>
            <tbody>{tableRows}</tbody>
        </table>
        </div>
    );
});

export default QuestionList;
